import { ExternalLink } from 'lucide-react';
import { PullRequestState, type PullRequestState as PullRequestStateT } from '@aiai/shared';
import { PR_STATE_TONE } from '../lib/statusTones';
import { Badge } from './Badge';

const LABEL: Record<PullRequestStateT, string> = {
  [PullRequestState.None]: '',
  [PullRequestState.Open]: 'PR open',
  [PullRequestState.Merged]: 'Merged',
  [PullRequestState.Closed]: 'PR closed',
};

/**
 * Real, GitHub-observed state of a run's pull request. Renders nothing when
 * there is no PR, or when the PR is merged and showMerged is not set (merged
 * runs already signal success via the row's state badge; this adds noise).
 * Stays clickable inside stretched-link rows (z-10 + stopPropagation).
 */
export function PrStateBadge({
  url,
  state,
  size = 'sm',
  showMerged = false,
}: {
  url: string | null;
  state: PullRequestStateT;
  size?: 'sm' | 'md';
  showMerged?: boolean;
}) {
  if (!url || state === PullRequestState.None) return null;
  if (state === PullRequestState.Merged && !showMerged) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer noopener"
      onClick={(e) => e.stopPropagation()}
      className="relative z-10 inline-flex shrink-0 transition hover:brightness-110"
    >
      <Badge tone={PR_STATE_TONE[state]} size={size} dot={false} className="gap-1">
        {LABEL[state]}
        <ExternalLink className="h-3 w-3" aria-hidden="true" />
      </Badge>
    </a>
  );
}
